// ----------------------------------------------------------------------




export const account = {
  displayName: 'OES User',
  email: 'oes@gmail.com',
  photoURL: '/assets/images/avatars/avatar_25.jpg',
};
